<template>
  <div class="admin-view">
    <router-view/>
  </div>
</template>
<script>
export default {
  name:'Admin'
}
</script>